const statuses = ['active', 'onHold', 'prospective', 'archived']

const getProjectTitle = (project) => {
    return project?.jobNumber && project?.name
        ? `${project?.jobNumber}: ${project?.name}`
        : project?.name || project?.jobNumber
}

export default (a, b) => {
    const titleA = getProjectTitle(a)
    const titleB = getProjectTitle(b)
    return (
        titleA?.toLowerCase?.()?.localeCompare?.(titleB?.toLowerCase?.()) || 0
    )
}
